/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useCallback, useContext, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import useStyles from "cms/fields/_styles";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { useTranslation } from "react-i18next";
import { isArrayNotEmpty } from "utils/empty-exists";
import debounce from "lodash.debounce";
// import useThrottle from 'hooks/useThrottle'

const EnumFieldItemEdit = () => {
    
    const { t } = useTranslation();
    // const throttler = useThrottle()
    const classes = useStyles();
    
    const ctx = useContext(ListItemContext);
    const { type, name, index, value, settings, updateListItem, disabled = false } = ctx || {};

    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { options: schemaOptions, styleOptions } = schemaSettings || {};
    
    // const ph = placeholder || t('commons.select')
    const ph = t("commons.select");

    // for value of ENUMERATION / SELECT
    const { select } = schemaOptions || {};
    const enumOptions = [];
    isArrayNotEmpty(select) &&
        select.map((item) =>
            enumOptions.push({
                label: item,
                value: item,
            }),
        );

    const initialState = {
        value: !value ? "" : value,
        settings,
    };
    const [itemLocalState, setItemLocalState] = useState(initialState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 1200),
        [updateListItem]
    );
    const onSettingsChange = (updateState) => {
        setItemLocalState(updateState);
        update(updateState, index);
    };
    const onChange = (event, value) => {
        const newValue = value?.value;
        const newState = { ...itemLocalState, value: newValue };
        setItemLocalState(newState);
        update(newState, index);
    };

    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                
                <div className='simplicity-composer-field-primary'>
                    {/*<Grid item xl={6} lg={6} md={6} sm={6} xs={12}>*/}
                    {isArrayNotEmpty(enumOptions) &&
                        <Autocomplete
                            id={`${name}_${type}_enum`}
                            className={classes.autoComplete}
                            // disableCloseOnSelect
                            options={enumOptions}
                            onChange={onChange}
                            disabled={disabled}
                            value={enumOptions.find((option) => option.label === itemLocalState.value)}
                            renderInput={(params) => (
                                <TextField
                                    placeholder={ph}
                                    variant='standard'
                                    {...params}
                                />
                            )}
                        />
                    }
                </div>
                {/*</Grid>*/}
                <DisplaySettingsWrapper>
                    {/*  Reads from schema options.styleOptions */}
                    {/*  records selection as value settings.style */}
                    <SettingsStyleEdit
                        type={type}
                        name={name}
                        label={t("commons.displayStyle")}
                        itemLocalState={itemLocalState}
                        setItemLocalState={setItemLocalState}
                        disabled={disabled}
                        styleOptions={styleOptions}
                        selected={itemLocalState?.settings?.style}
                        index={index}
                        update={onSettingsChange}
                    />
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
EnumFieldItemEdit.displayName = "EnumFieldItemEdit";
export {
    EnumFieldItemEdit
};
